import {
  Box,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getApplicants } from "../../../../Redux/Reducers/JobReducer";
import { offerStatuses, statusOptions } from "../../../Utilities/ListUtils";
import GlobalSearchCandidates from "../GlobalSearchCandidates";
import CandidateCard from "./CandidateCard";
import FilterChips from "./FilterChips";
import CandidatePagination from "./CandidatePagination";

const AllCandidatesInfo = () => {
  const dispatch = useDispatch();
  const allApplicantsData = useSelector(
    (state) => state?.jobs?.jobApplicantsData
  );
  const AllCandidates = allApplicantsData?.applicants;
  const TotalPages = allApplicantsData?.pagination;
  const appStatus = useSelector(
    (state) => state.jobs.selectedAllApplicantsStatus
  );
  const singlePostedJob = useSelector((state) => state?.jobs?.singlePostedJob);
  const Job_id = singlePostedJob?.posted_job?.id;
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [selectedStatuses, setSelectedStatuses] = useState([]);


  let applicantStatus = statusOptions?.includes(appStatus)
    ? appStatus
    : appStatus == "Offer"
    ? offerStatuses?.join("|")
    : "";

  const toggleStatus = (status) => {
    try {
      setSelectedStatuses((prev) => {
        let statuses = prev.includes(status)
          ? prev.filter((s) => s !== status)
          : [...prev, status];
        dispatch(
          getApplicants({
            job_id: Job_id,
            status: statuses?.join("|") || "",
          })
        );
        return statuses;
      });
    } catch {
      console.log("Error occured while filtering");
    }
  };

  const handlePage = (count) => {
    setPage(count);
    dispatch(
      getApplicants({
        job_id: Job_id,
        status: applicantStatus,
        page: count,
        search: searchText,
      })
    );
  };

  const onSearch = (text) => {
    console.log("text", text)
    setSearchText(text);
    try {
      dispatch(
        getApplicants({
          job_id: Job_id,
          status: selectedStatuses.join("|") || "", // Use selectedStatuses from local state
          search: text,
        })
      );
    } catch {
      console.log("Error occurred while Searching");
    }
  };

  let filterOptions = appStatus?.includes("Offer")
    ? offerStatuses
    : statusOptions;

  return (
    <Box
      sx={{ display: "flex", backgroundColor: "#f8f9fa", minHeight: "85vh" }}
    >
      <Box
        sx={{
          width: "70%",
          display: "flex",
          flexDirection: "column",
          p: 3,
          maxHeight: "90vh",
          overflowY: "scroll",
          scrollbarWidth: "none",
        }}
      >
        {/* Search Bar */}

        <Box
          sx={{
            display: "flex",
            width: "100%",
            mb: 3,
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ width: "50%", alignContent: "center" }}>
            <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>
              {selectedStatuses.length > 0
                ? selectedStatuses.join(", ")
                : "Showing all candidates"}
            </Typography>
          </Box>
          <Box sx={{ width: "50%" }}>
            <TextField
              fullWidth
              label="Search by name or role"
              variant="outlined"
              value={searchText}
              onChange={(e) => onSearch(e.target.value)}
            />
          </Box>
        </Box>

        {/* Status Chips */}
        {!appStatus || appStatus?.includes("Offer") ? (
          <FilterChips
            selectedStatuses={selectedStatuses}
            filterOptions={filterOptions}
            toggleStatus={toggleStatus}
          />
        ) : null}

        {/* Candidates Grid */}
        <Box
          sx={{
            backgroundColor: "white",
            padding: "15px",
            flexGrow: 1,
            boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
            borderRadius: "5px",
          }}
        >
          {AllCandidates?.length > 0 ? (
            <Grid container spacing={3}>
              {AllCandidates?.map((candidate) => (
                <CandidateCard candidate={candidate} />
              ))}
            </Grid>
          ) : (
            <Typography
              sx={{
                textAlign: "center",
                color: "gray",
                fontSize: "18px",
                mt: 3,
                fontWeight: "bold",
              }}
            >
              No matching candidates found
            </Typography>
          )}
        </Box>

        {/* Pagination */}
        <Box sx={{ display: "flex", justifyContent: "center", mt: 3, mb: 2 }}>
          <CandidatePagination
            totalPages={TotalPages?.totalPages}
            currentPage={page}
            onPageChange={handlePage}
          />
        </Box>
      </Box>

      {/* Sidebar */}
      <Box sx={{ width: "30%", p: 1, backgroundColor: "#f8f9fa" }}>
        <GlobalSearchCandidates />
      </Box>
    </Box>
  );
};

export default AllCandidatesInfo;
